export class CustomError extends Error {
}
